// extracted by mini-css-extract-plugin
export default {"wrap":"Wwy9BsGHj5ZFp0DZrrqQ","projectionsList":"Ir15yUzhpUZR90lPcrV8","zoomSettings":"LOZqp1OwXuCDKE_DlB5e","addButton":"sBK8SMVMjpxCW9wuuGs7"};